import type { DashboardPortfolioReport, PortfolioReport } from '../types';

export const getPortfolioName = (
  report: PortfolioReport | DashboardPortfolioReport,
): string => {
  const obj = report.object;
  if (!obj) return 'Portfolio';
  if (report.modelPortfolioType === 'GOAL') {
    const o = obj as {
      name?: string;
      user?: { firstName?: string; lastName?: string };
    };
    const user = o?.user;
    if (user?.firstName)
      return `${user.firstName} ${user.lastName || ''}`.trim();
    return o?.name || 'Goal Portfolio';
  }
  const o = obj as {
    account?: {
      type?: string;
      user?: { firstName?: string; lastName?: string };
    };
    goal?: { name?: string };
  };
  const user = o.account?.user;
  const acctType = o.account?.type;
  const goalName = o.goal?.name;
  const name = user
    ? `${user.firstName || ''} ${user.lastName || ''}`.trim()
    : '';
  const suffix = acctType ? ` · ${acctType}` : '';
  const goalSuffix = goalName ? ` · ${goalName}` : '';
  return `${name || 'Portfolio'}${suffix}${goalSuffix}`;
};
